//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import {
  ICustomGallery,
  IGallery,
  ISelfServeGallery,
} from '@apis/galleries/galleriesApiModels';
import { GALLERY_LOCATION } from '@galleries/models/galleriesStateModel';
import { ExperienceContainerType } from '@models/ExperienceContainerType';

export function isCustomGallery(gallery: IGallery): gallery is ICustomGallery {
  return !('containerType' in gallery);
}

export function isSelfServeGallery(
  gallery?: IGallery,
): gallery is ISelfServeGallery {
  return !!(gallery as ISelfServeGallery | undefined)?.containerType;
}

interface ISelfServeGalleryWithContainerType<T extends ExperienceContainerType>
  extends ISelfServeGallery {
  containerType: T;
}

export function isGalleryContainerType<T extends ExperienceContainerType>(
  gallery: IGallery,
  containerType: T,
): gallery is ISelfServeGalleryWithContainerType<T> {
  return isSelfServeGallery(gallery) && gallery.containerType === containerType;
}

export const galleryLocationToContainerType = (location: GALLERY_LOCATION) => {
  switch (location) {
    case GALLERY_LOCATION.HOMEPAGE:
      return ExperienceContainerType.HOMEPAGE;
    case GALLERY_LOCATION.CATEGORY_PAGE:
      return ExperienceContainerType.CATEGORY;
    case GALLERY_LOCATION.PRODUCT_PAGE:
      return ExperienceContainerType.PRODUCT;
    default:
      return ExperienceContainerType.OTHER;
  }
};

export const galleryLocationToLabel = (location: GALLERY_LOCATION) => {
  switch (location) {
    case GALLERY_LOCATION.HOMEPAGE:
      return 'Homepage';
    case GALLERY_LOCATION.PRODUCT_PAGE:
      return 'Product Page';
    case GALLERY_LOCATION.CATEGORY_PAGE:
      return 'Category Page';
    case GALLERY_LOCATION.OTHER_PAGE:
      return 'Other Page';
    default:
      return '';
  }
};
